export const phoneMaskUSA = {
  mask: '000 0000',
  placeholderChar: ''
}
